import { Link } from 'react-router-dom';
import './index.css';

const Footer = () => {
  return (
    <div className="page-footer">
      <div className="footer-links">
        <Link to="/about-us">关于我们</Link>
        <span className="separator">|</span>
        <Link to="/disclaimer">免责声明</Link>
        <span className="separator">|</span>
        {/* 
        <Link to="/contact-us">联系我们</Link>
        <span className="separator">|</span>        
        <Link to="/new">最新上线</Link>
        <span className="separator">|</span>
        <Link to="/changelog">更新日志</Link>
        <span className="separator">|</span>
        <Link to="/feedback">反馈建议</Link>
        <span className="separator">|</span>
        */}
        <Link to="/privacy-policy">隐私政策</Link>
        <span className="separator">|</span>
        <Link to="/cookie-policy">Cookie政策</Link>
      </div>

      <div className="footer-copyright">
        <span className="copyright-text">© 2026 麒麟鱼-生图工具网 All Rights Reserved</span>
        <span className="beian-list">
          <a  className="beian-link" href="https://beian.miit.gov.cn" target='_blank'>浙ICP备2026065541号-1</a>
          <a  className="beian-link police-beian" href="https://beian.mps.gov.cn/#/query/webSearch?code=33010202006238" rel="noreferrer" target="_blank"><img src="../beian-police.png" alt="公安备案图标" className="police-beian-icon" width={16} height={17.281} />浙公网安备33010202006238号</a>
        </span>
      </div>
    </div>
  );
};

export default Footer;